// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./background-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  box-shadow: var(--card-shadow);
  height: auto;
  /* font-family: Arial, Helvetica, sans-serif; */
}

.btn-all-submit {
  background-color: var(--button-background);
  color: var(--whitefont-color);
  box-shadow: var(--button-box-shadow);
  margin-left: 9px;
}

.btn-all-submit:hover {
  background-color: #0a66c2;
  color: var(--whitefont-color);
}

.btn.btn-secondary.btn-all-submit:hover,
.btn.btn-secondary.btn-all-submit:active,
.btn.btn-secondary.btn-all-submit:focus {
    background-color: #0a66c2 !important;
    color: var(--whitefont-color) !important;
    border-color: #0a66c2 !important; /* optional */
}



.breadcrumb.nav-breadcrumb{
    text-decoration: none;
    font-size: 12px;
  }

.breadcrumb.nav-breadcrumb a{
    text-decoration: none;
    font-size: 12px;
  }

  
  .label-black{
  cursor: pointer;
  margin-right: 10px;
  color: var(--blackfont-color);
  }
  .rest-button-color{
 background-color: var(--button-background);
 color: var(--whitefont-color);
 box-shadow: var(--button-box-shadow);
  }

  .rest-button-color:hover {
    background-color: var(--button-background-hover);
    color: var(--whitefont-color);
  }

  .mb-1-1 {
    margin-bottom: 1.1rem !important;
  }


  





`, "",{"version":3,"sources":["webpack://./src/assets/css/TemplateForm.css"],"names":[],"mappings":"AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;;IAGI,oCAAoC;IACpC,wCAAwC;IACxC,gCAAgC,EAAE,aAAa;AACnD;;;;AAIA;IACI,qBAAqB;IACrB,eAAe;EACjB;;AAEF;IACI,qBAAqB;IACrB,eAAe;EACjB;;;EAGA;EACA,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B;EACA;CACD,0CAA0C;CAC1C,6BAA6B;CAC7B,oCAAoC;EACnC;;EAEA;IACE,gDAAgD;IAChD,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC","sourcesContent":["@import './background-colors.css';\r\n\r\n.card {\r\n  box-shadow: var(--card-shadow);\r\n  height: auto;\r\n  /* font-family: Arial, Helvetica, sans-serif; */\r\n}\r\n\r\n.btn-all-submit {\r\n  background-color: var(--button-background);\r\n  color: var(--whitefont-color);\r\n  box-shadow: var(--button-box-shadow);\r\n  margin-left: 9px;\r\n}\r\n\r\n.btn-all-submit:hover {\r\n  background-color: #0a66c2;\r\n  color: var(--whitefont-color);\r\n}\r\n\r\n.btn.btn-secondary.btn-all-submit:hover,\r\n.btn.btn-secondary.btn-all-submit:active,\r\n.btn.btn-secondary.btn-all-submit:focus {\r\n    background-color: #0a66c2 !important;\r\n    color: var(--whitefont-color) !important;\r\n    border-color: #0a66c2 !important; /* optional */\r\n}\r\n\r\n\r\n\r\n.breadcrumb.nav-breadcrumb{\r\n    text-decoration: none;\r\n    font-size: 12px;\r\n  }\r\n\r\n.breadcrumb.nav-breadcrumb a{\r\n    text-decoration: none;\r\n    font-size: 12px;\r\n  }\r\n\r\n  \r\n  .label-black{\r\n  cursor: pointer;\r\n  margin-right: 10px;\r\n  color: var(--blackfont-color);\r\n  }\r\n  .rest-button-color{\r\n background-color: var(--button-background);\r\n color: var(--whitefont-color);\r\n box-shadow: var(--button-box-shadow);\r\n  }\r\n\r\n  .rest-button-color:hover {\r\n    background-color: var(--button-background-hover);\r\n    color: var(--whitefont-color);\r\n  }\r\n\r\n  .mb-1-1 {\r\n    margin-bottom: 1.1rem !important;\r\n  }\r\n\r\n\r\n  \r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
